import type { FC, MouseEventHandler } from 'react';

import { Box, Icon, IconProps, Switch, Tooltip, Typography } from '@myn/mui';

type Props = {
  checked: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  label?: string | null;
  icon?: IconProps['component'] | null;
  tooltip: string;
  disabled?: boolean;
};

const SwitchWithLabel: FC<Props> = ({
  checked,
  onClick,
  icon,
  label,
  tooltip,
  disabled = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        columnGap: 1,
        color: disabled ? 'text.disabled02' : 'auto',
      }}
    >
      <Switch
        aria-label="Carbon offset toggle"
        size="small"
        checked={checked}
        onClick={onClick}
        disabled={disabled}
      />
      {label && (
        <Typography variant="bodyShort01" whiteSpace="nowrap">
          {label}
        </Typography>
      )}
      {icon && <Icon component={icon} />}
      <Tooltip title={tooltip} placement="top">
        <Box display="flex">
          <Icon component="Information" />
        </Box>
      </Tooltip>
    </Box>
  );
};

export default SwitchWithLabel;
